var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-content"},[_c('JsonDisplay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }